import { defineStore } from 'pinia';
import { MessageType } from '@/types/MessageType';
import { toast } from 'vue3-toastify';

export const useMessagesStore = defineStore('messagesStore', {
  state: () => ({
    messages: [] as MessageType[],
  }),
  getters: {
    getUnshowedMessages(state) {
      return state.messages.filter((m) => !m.showed);
    },
  },
  actions: {
    insertMessage(message: MessageType) {
      this.messages.push(message);
    },
    toastUnshowedMessages() {
      this.messages
        .filter((m: MessageType) => !m.showed)
        .forEach((msg: MessageType) => {
          toast(msg.message, { type: msg.type });
          msg.showed = true;
        });
    },
  },
});
